<template>
  <section>
    <div class="search-page">
      <base-breadcrumb
        v-if="isDealerMicroSite"
        :links="[dealerName, $t('shared.used-cars')]"
        class="search-page__breadcrumb"
      />
      <model-select />
      <price-range-select />
      <year-select />
      <transmission-select />
      <fuel-type-select />
      <dealer-location-select v-if="!isDealerMicroSite" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import BaseBreadcrumb from "@/components/ui/BaseBreadcrumb/BaseBreadcrumb.vue";
import ModelSelect from "@/components/search/ModelSelect/ModelSelect.vue";
import PriceRangeSelect from "@/components/search/PriceRangeSelect/PriceRangeSelect.vue";
import YearSelect from "@/components/search/YearSelect/YearSelect.vue";
import TransmissionSelect from "@/components/search/TransmissionSelect/TransmissionSelect.vue";
import FuelTypeSelect from "@/components/search/FuelTypeSelect/FuelTypeSelect.vue";
import DealerLocationSelect from "@/components/search/DealerLocationSelect/DealerLocationSelect.vue";
import { GET_DATA_FROM_API, UPDATE_REGIONS_LIST } from "@/store/actionTypes";
import { CLEAR } from "@/store/mutationTypes";

export default {
  name: "Search",
  components: {
    BaseBreadcrumb,
    ModelSelect,
    PriceRangeSelect,
    YearSelect,
    TransmissionSelect,
    FuelTypeSelect,
    DealerLocationSelect
  },
  computed: {
    ...mapGetters(["isDealerMicroSite", "dealerName"])
  },
  beforeCreate() {
    this.$store.commit(CLEAR);
  },
  mounted() {
    this.$store.dispatch(GET_DATA_FROM_API);
    this.$store.dispatch(UPDATE_REGIONS_LIST);
  }
};
</script>

<style lang="scss" scoped>
.search-page {
  margin: 0 20px;

  &__breadcrumb {
    margin-top: 20px;
  }
}

@media screen and (min-width: $media-l) {
  .search-page__breadcrumb {
    margin-top: 40px;
  }
}

@media screen and (min-width: $media-xl) {
  .search-page {
    margin: 0;
  }
}
</style>
